<template>

  <div id="classroom" class="uk-background-default" uk-grid>

    <nav class="uk-navbar-container uk-width-1-1 uk-background-primary" uk-navbar>
      <div class="uk-navbar-left">
          <router-link to="/a202" class="uk-navbar-item uk-logo">A202</router-link>
      </div>
      <div class="uk-navbar-right">
        <ul class="uk-navbar-nav">
            <li>
              <a href="#">Quick Links</a>
              <div class="uk-navbar-dropdown">
                <ul class="uk-nav uk-navbar-dropdown-nav" uk-nav="multiple: true"> 
                  <li><a href="https://meet.google.com/lookup/h54m65h2qe?authuser=0&hs=179" target="_blank">Google Meet</a></li>
                  <li><a href="https://classroom.google.com/" target="_blank">Google Classroom</a></li>
                  <li><a href="https://kahoot.com/schools-u/" target="_blank">Kahoot</a></li>
                  <li><a href="https://connected.mcgraw-hill.com/connected/login.do" target="_blank">Wonders</a></li>
                  <li><a href="https://clever.com" target="_blank">iReady</a></li>
                  <li><a href="https://www.ixl.com/" target="_blank">iXL</a></li>
                  <li><a href="https://sn3.scholastic.com/" target="_blank">Scholastic</a></li>
                  <li><a href="https://signin.acellus.com/SignIn/" target="_blank">Acellus</a></li>
                </ul>
              </div>
            </li>
            <li>
                <a href="#">{{ getUser.displayName }}</a>
                <div class="uk-navbar-dropdown">
                    <ul class="uk-nav uk-navbar-dropdown-nav">
                        <li><a href="#" @click="logout">Logout</a></li>
                    </ul>
                </div>
            </li>
        </ul>
      </div>
    </nav>
    
    <div class="uk-margin-remove uk-height-viewport uk-width-1-1 uk-child-width-expand" uk-grid>
      <div id="left" class="uk-width-medium uk-background-muted">
          <Schedule></Schedule>
      </div>

      <div id="main">
        
        <router-view></router-view>

      </div>
    </div>
  </div>

</template>

<script>
import { mapActions } from "vuex";
import { mapGetters } from "vuex";

import Schedule from "../components/Schedule.vue";

export default {
  name: "A202",
  components: {
    'Schedule': Schedule
  },
  methods: {
    ...mapActions(["logoutAction"]),
    logout() {
      this.logoutAction();
    }
  },
   computed: {
    ...mapGetters(["getUser", "isUserAuth"])
  }
};
</script>
